function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React, { FC, ComponentType } from 'react';
import { IBreadcrumb } from '..';
import { Icon, IIconProps } from '../../Icon';
import { Popup, bindSupportingElement, usePopupState } from '../../Popup';
import { useUniqId } from '../../../hooks/useUniqId';
require("./Breadcrumb.css");
var styles = {
  "Root": "Breadcrumb-module-Root_2dE",
  "Item": "Breadcrumb-module-Item_xNt",
  "Siblings": "Breadcrumb-module-Siblings_26G",
  "Separator": "Breadcrumb-module-Separator_XLG",
  "Link": "Breadcrumb-module-Link_2JF"
};
require("../Breadcrumbs.css");
var parentStyles = {
  "Root": "Breadcrumbs-module-Root_SHl",
  "List": "Breadcrumbs-module-List_1HW",
  "Popup": "Breadcrumbs-module-Popup_2SX"
};
export const Breadcrumb = ({
  isCurrent = false,
  label,
  linkComponent = 'a',
  separatorIcon = 'chevronRight',
  subList,
  to
}) => {
  const subListId = useUniqId('sub-list-breadcrumb');
  const breadcrumbId = useUniqId('breadcrumb');
  const popupState = usePopupState({
    triggers: ['focus', 'hover']
  });
  const ComponentLink = linkComponent;
  const linkHrefProp = linkComponent === 'a' ? 'href' : 'to';
  return /*#__PURE__*/React.createElement("li", _extends({
    className: styles.Item,
    itemProp: "itemListElement",
    itemScope: true,
    itemType: "https://schema.org/ListItem",
    tabIndex: 0
  }, subList && subList.length > 0 && {
    ...bindSupportingElement(subListId, popupState)
  }), /*#__PURE__*/React.createElement(ComponentLink, {
    className: styles.Link,
    [linkHrefProp]: to,
    id: breadcrumbId,
    "aria-current": isCurrent ? 'page' : undefined
  }, label), subList && subList.length > 0 && /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Icon, {
    "aria-hidden": "true",
    className: styles.Siblings,
    name: 'chevronDown',
    size: "s"
  }), /*#__PURE__*/React.createElement(Popup, {
    id: subListId,
    isVisible: popupState.visibleId === subListId,
    target: popupState.supportingHTMLElement,
    variant: "default",
    placement: "bottom-start",
    className: styles.Popup
  }, /*#__PURE__*/React.createElement("ol", {
    itemScope: true,
    itemType: "https://schema.org/BreadcrumbList",
    role: "group",
    "aria-labelledby": breadcrumbId,
    className: parentStyles.List
  }, subList.map((child, i) => /*#__PURE__*/React.createElement("li", {
    itemProp: "itemListElement",
    itemScope: true,
    itemType: "https://schema.org/ListItem",
    key: i
  }, /*#__PURE__*/React.createElement(ComponentLink, {
    [linkHrefProp]: child.to,
    className: styles.Link
  }, child.label)))))), !isCurrent && /*#__PURE__*/React.createElement(Icon, {
    name: separatorIcon,
    "aria-hidden": "true",
    size: "m",
    className: styles.Separator
  }));
};